import { render, staticRenderFns } from "./FrzPackingObservation.vue?vue&type=template&id=76a9fac6"
import script from "./FrzPackingObservation.vue?vue&type=script&lang=js"
export * from "./FrzPackingObservation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports